export default ({ theme }) => `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;


  .partnerships-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 1066px;
    padding: 20px;
    color: #000;

    h1 {
      margin: 30px 0;

      .partner-content-container {
        width: calc(100% - 20px);
        padding: 10px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        margin: 10px 0 40px;
        min-height: calc(100vh - 400px);

        .partner-container{
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          width: 100%;
          padding: 20px;
          color: #000;
      
      
          h2 {
            font-weight: bolder;
          }
      
          p {
            margin: 10px 0;
            font-size: larger;
          }
      
          ul {
            list-style-type: disc;
          }
      
          li {
            margin: 10px 0;
            font-size: larger;
          }
      
          a {
            color: #000;
            text-decoration: underline;
          }
      
        }


      }

  }

  .links-container {
    .payment-method-designation {
      background-color: ${theme.lightBorderColor};
      padding: 10px 10px;
      margin-top: 10px;

      .switcher {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: solid 1px ${theme.borderColor};
      }
    }
  }

  .acceptance-card{
    display: flex;
    flex-direction: column;
    /* max-width: 50%; */
    padding: 20px;
    margin: 20px;
    background-color: ${theme.promotedBackgroundColor};
    border-radius: 5px;

    h2 {
      font-weight: bolder;
      text-align: center;
    }
  }

 

`;
